import { Component, OnInit } from '@angular/core';
import { EditorService } from '../services/editor.service';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { DynamicInputComponent, MenuGroup } from '../dynamic-input-model';
import { CategoryInputComponent } from './category-input/category-input.component';

@Component({
  selector: 'kve-category-editor',
  templateUrl: './category-editor.component.html',
  styleUrls: ['./category-editor.component.scss']
})
export class CategoryEditorComponent implements OnInit {
  inputComponent = new DynamicInputComponent(CategoryInputComponent);
  menuGroups:any;
  title = "Editing Category Route";
  menuTag = "editCategoryPageRouteMenu";
  menuGroup:MenuGroup = {
    title:"Editing Category Page Route",
    menuTag:"editCategoryPageRouteMenu",
    menuItems: [
      {
        title:"Page Settings"
      },
      {
        title:"Sections"
      },
      {
        title:'Add Section',
        children:[
          {
            title:'Grid',
            children:[
              {
                title:'Add New Grid'
              },
              {
                title:'Edit Existing Grid'
              }
            ]
          },
          {
            title:'Banner'
          },
          {
            title:'Slider'
          },
          {
            title:'Slide Show'
          }
        ]
      },
      {
        title:'Remove Section',
      },
      {
        title:'Order Sections',
      },
    ]
  }
  menuItems:NbMenuItem[] = [
    {
      title:'Settings'
    },
    {
      title:'Sections'
    },
    {
      title:'Add Section',
    },
    {
      title:'Remove Section'
    },
    {
      title:'Order Sections'
    }
  ]
  previousMenu:NbMenuItem[] = [];
  

  constructor(private editorService:EditorService,
    private menuService:NbMenuService) { }

  ngOnInit(): void {
    this.menuGroups = this.editorService.createMenusFromGroup(this.menuGroup);
    this.inputComponent.data = this.menuGroups;
    this.editorService.setInputComponent(this.inputComponent);
    console.log(this.menuGroups);
    this.menuService.onItemClick().subscribe(menuBag =>{
      console.log({menuBag:menuBag});
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        //if(selectedItem.parent.title)
        this.setMenu(selectedItem);
        console.log({selectedItem:selectedItem});
      }
    })
  }

  setMenu(selectedItem:NbMenuItem){
    if(selectedItem.title == "Back"){
      this.menuItems = this.previousMenu;
    }else{
      this.menuGroup.menuItems.forEach(menuItem => {
        if(menuItem.title == selectedItem.title && menuItem.children != null){
          this.previousMenu = this.menuItems;
          console.log(menuItem.title);
          let backLinkLNbMenuItem = {title:"Back",icon:"arrow-back-outline"};
          let headerItem:NbMenuItem = {title:menuItem.title,group:true}
          this.menuItems = [backLinkLNbMenuItem,headerItem].concat(menuItem.children);
        }
      })
    }
    
  }

}
